module.exports = __webpack_public_path__ + "img/5-2.44898a80.jpg";